import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarView = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .799951,
			y: 1.40078,
			width: 21.2,
			height: 18.8,
			rx: 5.8,
			stroke: "black",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 8H1",
			stroke: "black",
			strokeWidth: 1.2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 2V20",
			stroke: "black",
			strokeWidth: 1.2
		})
	]
});
export default SvgCalendarView;
